import { Component, Input, OnInit } from '@angular/core';
import { AvailableServices } from '../../meeting-services';
import { MeetingViewModelService } from '../../meeting-view-model/meeting-view-model.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'integrations-connect-to-service',
  templateUrl: './connect-to-service.component.html',
  standalone: false,
})
export class ConnectToServiceComponent implements OnInit {
  @Input() service: AvailableServices;
  @Input() useAlternateStyling: boolean;
  @Input() connectionInfoKey?: string;

  serviceConnected$: Observable<boolean>;

  constructor(private readonly viewModel: MeetingViewModelService) {}

  ngOnInit(): void {
    this.serviceConnected$ = this.viewModel.isServiceConnected$(this.service);
  }

  toggleConnectionElementClicked(): void {
    this.viewModel.toggleConnection(this.service, this.connectionInfoKey);
  }
}
